import { render } from "./clinic-doctor-dashboard.vue?vue&type=template&id=65fddc6e&scoped=true"
import script from "./clinic-doctor-dashboard.vue?vue&type=script&lang=js"
export * from "./clinic-doctor-dashboard.vue?vue&type=script&lang=js"

import "./clinic-doctor-dashboard.vue?vue&type=style&index=0&id=65fddc6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fddc6e"]])

export default __exports__